import React, { Fragment } from 'react';
import { Grid } from '@material-ui/core';
import _ from 'lodash'
import numeral from 'numeral';
import styled from 'styled-components';
import { connect as reduxConnect } from "react-redux";
import { connect } from 'formik';
import { compose} from "redux";
import interestRateTypes, {interestRateTypeList} from 'constants/interestRateTypes';
import amortizationTypes, { amortizationTypeList } from 'constants/amortizationTypes';
import {
  ChildSectionTitle,
  SideLabelAutoCompleteInput,
  SideLabelDateInput,
  SideLabelTextAreaInput,
  SideLabelIntegerInput,
  SideLabelPercentInput,
  SideLabelMoneyInput,
  SideLabelCalculatedField,
 } from '../FormSectionComponents';  

const AmortizationDetailsGrid = styled(Grid)`
  &&& {
    width:1000px;
  }
`

class AmortizationDetailsChildSection extends React.Component {

  getAmortizationType = values => _.get(values, 'amortizationDetails.amortizationTypeId');
  getInterestRateType = values => _.get(values, 'details.rateTypeId');
  isFloating = interestRateTypeId => interestRateTypes.FLOATING === interestRateTypeId;
  isStraightLine = amortizationTypeId => amortizationTypes.STRAIGHT_LINE_CUSTOM_AMORT === amortizationTypeId;
  isMortgageStyle = amortizationTypeId => amortizationTypes.MORTGAGE_STYLE === amortizationTypeId;
  isInterestOnly = amortizationTypeId => amortizationTypes.INTEREST_ONLY === amortizationTypeId

  render(){
    const { isEditing, formik , isQuote} = this.props;
    const { values } = formik;

    const interestRateTypeId = this.getInterestRateType(values);
    const amortizationTypeId = this.getAmortizationType(values);
    const isStraightLine = this.isStraightLine(amortizationTypeId);
    const isFloating = this.isFloating(interestRateTypeId);
    const isMortgageStyle = this.isMortgageStyle(amortizationTypeId);
    const isInterestOnly = this.isInterestOnly(amortizationTypeId);

    return (
      <Fragment>
        <div id="loan_section_amort_details">
          <ChildSectionTitle>Amortization Details</ChildSectionTitle>        
          <AmortizationDetailsGrid container alignItems="center" direction="column">
            {!isInterestOnly && <SideLabelDateInput 
              label="Amortization Start Date"
              placeholder="MM/DD/YYYY"
              fieldName="amortizationDetails.amortizationStartDate"
              isDisabled={!isEditing}
              shouldHideForQuote={isQuote}
            />}
            {!isInterestOnly && <SideLabelIntegerInput
              label="Amortization Term"
              fieldName="amortizationDetails.amortizationTerm"
              placeholder="Amortization Term"
              isDisabled={!isEditing}
            />}
            <SideLabelAutoCompleteInput 
              label="Amortization Type"
              id="dropdownForAmortizationType"
              fieldName="amortizationDetails.amortizationTypeId"            
              selectValue="value"
              options={amortizationTypeList}
              isDisabled={!isEditing}
            />
            {isMortgageStyle && <SideLabelCalculatedField
              label="Monthly Payment"
              calculationFunc={values => numeral(_.get(values, 'details.currentPayment')).format('$0,0')}
              placeholder="Monthly Payment"
              isDisabled={!isEditing}
            />}
            {(isStraightLine && !values.details.cashflowOverrideTypeId) && <SideLabelMoneyInput
              label="Monthly Principal Reduction"
              fieldName="amortizationDetails.monthlyPrincipalReduction"
              placeholder="Monthly Principal Reduction"
              isDisabled={!isEditing}
            />}
            {(isMortgageStyle && isFloating && !values.details.cashflowOverrideTypeId) && <SideLabelPercentInput
              label="Amortization Rate"
              placeholder="Amortization Rate"
              fieldName="amortizationDetails.amortizationRate"
              isDisabled={!isEditing}
              decimalScale={3}
            />}
            {!isQuote && !isInterestOnly && <SideLabelCalculatedField
              label="I/O Periods"
              calculationFunc={values => {
                return _.get(values,"amortizationDetails.ioPeriod")
              }}
              placeholder="Interest Only Periods"
              isDisabled={!isEditing}
            />}
            {isQuote && !isInterestOnly && <SideLabelTextAreaInput
                          label="I/O Periods"
                          placeholder="I/O Periods"
                          fieldName="amortizationDetails.ioPeriod"
                          isDisabled={!isEditing}
                          />}


            <SideLabelTextAreaInput
              label="Amortization Details"
              placeholder="Amortization Details"
              fieldName="amortizationDetails.amortization"
              isDisabled={!isEditing}
              />
              <SideLabelTextAreaInput
              label="Interest Calculation"
              placeholder="Interest Calculation"
              fieldName="amortizationDetails.interestCalculation"
              isDisabled={!isEditing}
              />
              <SideLabelTextAreaInput
              label="Misc"
              placeholder="Misc"
              fieldName="amortizationDetails.amortMisc"
              isDisabled={!isEditing}
              />

          </AmortizationDetailsGrid>
        </div>
      </Fragment>
  )};
}

const mapStateToProps = ({  }) => ({
});

export default compose(  
  connect,
  reduxConnect(
    mapStateToProps,
    {
    }
  )
)(AmortizationDetailsChildSection);
